<template>
	<v-autocomplete
		@input="handleSelectBrand"
		:items="items"
		:loading="isAutoCompleting"
		:search-input.sync="searchTerm"
		:clearable="true"
		:value="model"
		:label="label"
		:prepend-icon="prependIcon"
		item-text="MergedTitle"
		item-value="id"
		placeholder="Start typing to Search"
		return-object>
		<template
			slot="item"
			slot-scope="{ item, tile }"
			 v-if="item">
			<v-list-tile-content>
				<v-list-tile-title v-text="item.title"></v-list-tile-title>
			</v-list-tile-content>
		</template>
	</v-autocomplete>
</template>

<script>
	import * as config from '@/config'
    import * as types from '@/stores/mutation-types'

	export default {
		props: {
			value: {
				type: [Object],
				default: null
			},
			label: {
				type: String,
				default: 'Search for a brand...'
			},
			prependIcon: {
				type: [String, Boolean],
				default: 'search'
			}
		},
		data () {
			return {
				descriptionLimit: 60,
				autoCompletedBrands: [],
				isAutoCompleting: false,
				entries: [],
				model: null,
				searchTerm: null
			}
		},
		computed: {
			fields () {
				if (!this.model) return []

				return Object.keys(this.model).map(key => {
					return {
						key,
						value: this.model[key] || 'n/a'
					}
				})
			},
			items () {
				if (!this.entries) return []

				return this.entries.map(entry => {
					// const title = entry.title.length > this.descriptionLimit
					// 	? entry.title.slice(0, this.descriptionLimit) + '...'
					// 	: entry.title
					const MergedTitle = entry.title

					return Object.assign({}, entry, { MergedTitle })
				})
			}			
		},
		methods: {
			handleSelectBrand(item) 
			{
				this.model = item
				if (item) {
					this.$emit('input', item)
				} else {
					this.$emit('input', null)
				}
			},
			initComponent ()
			{
				this.entries = []
				this.model = null
				this.searchTerm = null

				if (typeof this.value === 'undefined') {
				} else if (this.value) {
					let entry = this.value

					const MergedTitle = entry.title

					// return Object.assign({}, entry, { MergedTitle })
					Object.assign({}, entry, { MergedTitle })

					this.entries.push(entry)
					this.model = entry
				}
			}		
		},
		mounted () {
			this.initComponent()
		},
		watch: {
			value (props) {
				this.initComponent()
			},
			searchTerm (val) {
				if (!val) return
				if (val.length < 3) return

				// Items have already been loaded
				// if (this.items.length > 0) return

				// Items have already been requested
				if (this.isAutoCompleting) return

				this.isAutoCompleting = true

				// Lazily load input items
				fetch(`${config.BASE_URL}/brand/search?keyword=${val}`)
					.then(res => res.json())
					.then(res => {
						const { totalRecords, brandList } = res.data

						this.count = totalRecords
						this.entries = brandList
					})
					.catch(err => {
						console.log(err)
					})
					.finally(() => {
						this.isAutoCompleting = false
					})
			}
		}
	}
</script>

<style lang="scss">
	
</style>